// extracted by mini-css-extract-plugin
export default {"tm-form":"tm-form___wTJ8y"};